document.addEventListener('DOMContentLoaded', () => {
  const accordionItems = document.querySelectorAll('.accordion-item');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const transitionHandlerKey = '__accordionTransitionHandler';

  accordionItems.forEach(item => {
    const header = item.querySelector('.accordion-item--header');
    const content = item.querySelector('.accordion-item--content');

    if (!header || !content) {
      return;
    }

    header.addEventListener('click', () => toggleAccordionItem(item, content));

    if (item.classList.contains('is-open')) {
      item.classList.add('active');
      content.style.height = 'auto';
    } else {
      content.style.height = '';
    }
  });

  function toggleAccordionItem(item, content) {
    if (item.classList.contains('active')) {
      closeAccordionItem(item, content);
    } else {
      openAccordionItem(item, content);
    }
  }

  function bindTransitionEnd(content, callback) {
    if (content[transitionHandlerKey]) {
      content.removeEventListener('transitionend', content[transitionHandlerKey]);
    }

    const handler = event => {
      if (event.propertyName !== 'height') {
        return;
      }

      content.removeEventListener('transitionend', handler);
      content[transitionHandlerKey] = null;
      callback();
    };

    content[transitionHandlerKey] = handler;
    content.addEventListener('transitionend', handler);
  }

  function openAccordionItem(item, content) {
    item.classList.add('active');

    if (prefersReducedMotion) {
      content.style.height = 'auto';
      return;
    }

    const startHeight = content.offsetHeight;
    const targetHeight = content.scrollHeight;

    content.style.height = `${startHeight}px`;
    content.offsetHeight;

    requestAnimationFrame(() => {
      content.style.height = `${targetHeight}px`;
    });

    bindTransitionEnd(content, () => {
      content.style.height = 'auto';
    });
  }

  function closeAccordionItem(item, content) {
    if (prefersReducedMotion) {
      content.style.height = '';
      item.classList.remove('active');
      return;
    }

    const startHeight = content.scrollHeight;
    content.style.height = `${startHeight}px`;
    content.offsetHeight;

    item.classList.remove('active');

    requestAnimationFrame(() => {
      content.style.height = '0px';
    });

    bindTransitionEnd(content, () => {
      content.style.height = '';
    });
  }
});